import React from 'react';
import {Link} from "umi";
import './index.less'

const solution = () => {
  const selectItems: FunctionItem[] = [
    {
      id: 'solution/company',
      title: '物业公司',
    },
    {
      id: 'solution/streetOrCommunities',
      title: '街道/社区',
    },
    {
      id: 'solution/communities',
      title: '社区O2O',
    },
    {
      id: 'solution/developer',
      title: '地产开发商',
    },
  ];
  return <div className="colution">
    <div className="item_box">
      {
        selectItems.map((item, index) => (
          <Link className={"text"} to={item.id}>{item.title}</Link>
        ))
      }
    </div>
  </div>;
};

export default solution;
